import { Button, Card, Form, Input, message, Modal, Breadcrumb, Divider } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ExclamationCircleOutlined, ArrowLeftOutlined, SaveOutlined, DeleteOutlined, HomeOutlined, PictureOutlined, InfoCircleOutlined } from "@ant-design/icons";
import CustomUpload from "../customUpload";
import slugify from "slugify";

export default function TopicForm({
    id = "",
    initialValues = {},
    onSubmit = () => {},
}) {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const deleteTopic = async () => {
        await axios
            .delete(`${process.env.REACT_APP_API_URL}/topic/deleteBySlug/${initialValues?.slug}`)
            .then(() => {
                message.success("Xoá topic thành công");
                navigate("/admin/topic");
            });
    };

    const handleTopicSlugChange = (e) => {
        form.setFieldValue("slug", slugify(e.target.value, { lower: true }));
    };

    useEffect(() => {
        if (Object.keys(initialValues)?.length > 0) {
            form.resetFields();
        }
    }, [form, initialValues]);

    const confirmDelete = () => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có chắc chắn xoá topic này?",
            okText: "Xác nhận",
            cancelText: "Huỷ",
            onOk: () => deleteTopic(),
        });
    };

    return (
        <div>
            {/* Header */}
            <div className="mb-6">
                <Breadcrumb items={[
                    { title: <Link to="/admin"><HomeOutlined /> Dashboard</Link> },
                    { title: <Link to="/admin/topic">Topic</Link> },
                    { title: id ? "Chỉnh sửa" : "Tạo mới" },
                ]} />
                <div className="flex items-center justify-between mt-4">
                    <div className="flex items-center gap-3">
                        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/admin/topic")} />
                        <h1 className="text-2xl font-bold text-gray-800 m-0">
                            {id ? "Chỉnh sửa Topic" : "Tạo Topic mới"}
                        </h1>
                    </div>
                    <div className="flex items-center gap-2">
                        {id && (
                            <Button danger icon={<DeleteOutlined />} size="large" onClick={confirmDelete}>
                                Xoá
                            </Button>
                        )}
                        <Button type="primary" size="large" icon={<SaveOutlined />}
                            className="bg-blue-500 min-w-[140px] font-semibold shadow-md"
                            onClick={() => form.submit()}>
                            {id ? "Cập nhật Topic" : "Tạo Topic"}
                        </Button>
                    </div>
                </div>
            </div>

            <Form
                layout="vertical"
                colon={false}
                form={form}
                initialValues={initialValues}
                onFinishFailed={(e) => console.log(e)}
                onFinish={onSubmit}
            >
                {/* Basic Info Card */}
                <Card
                    title={<span className="text-base"><InfoCircleOutlined className="mr-2 text-blue-500" />Thông tin cơ bản</span>}
                    className="mb-5 shadow-sm rounded-xl border-0"
                    headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                    <Form.Item
                        label="Tiêu đề"
                        name="title"
                        rules={[{ required: true, message: "Vui lòng nhập tiêu đề!" }]}
                    >
                        <Input size="large" placeholder="Nhập tiêu đề topic" onChange={handleTopicSlugChange} />
                    </Form.Item>
                    <Form.Item
                        label="Slug (URL)"
                        name="slug"
                        rules={[{ required: true, message: "Vui lòng nhập slug!" }]}
                        extra="Tự động tạo từ tiêu đề, có thể chỉnh sửa"
                    >
                        <Input size="large" placeholder="slug-cua-topic" onBlur={handleTopicSlugChange} />
                    </Form.Item>
                    <Form.Item
                        label="Mô tả ngắn"
                        name="description"
                        extra="Hiển thị dưới tiêu đề trên trang chủ"
                    >
                        <Input.TextArea rows={3} placeholder="Nhập mô tả ngắn cho topic" showCount maxLength={200} />
                    </Form.Item>
                </Card>

                {/* Image Card */}
                <Card
                    title={<span className="text-base"><PictureOutlined className="mr-2 text-green-500" />Hình ảnh</span>}
                    className="mb-5 shadow-sm rounded-xl border-0"
                    headStyle={{ borderBottom: '2px solid #f0f0f0' }}
                >
                    <Form.Item
                        label="Ảnh đại diện"
                        name="image_url"
                        rules={[{ required: true, message: "Vui lòng chọn ảnh!" }]}
                    >
                        <CustomUpload type="image" accept=".png, .jpg, .jpeg, .jfif" />
                    </Form.Item>
                    <Divider dashed className="my-2">hoặc nhập URL</Divider>
                    <Form.Item name="image_url">
                        <Input size="large" placeholder="https://example.com/image.jpg" />
                    </Form.Item>
                </Card>
            </Form>
        </div>
    );
}
